import RelatedDetail from '../../../related/_detail';

// Related site detail (EN). Copy and images: src/data/related/the-butler.ts; FAQ: src/data/faq.json (/en/related/the-butler).
export default function EnRelatedTheButlerPage() {
  return <RelatedDetail slug="the-butler" lang="en" />;
}
